<template>
  <li v-if="this.bookingTermsAreAccepted">
    <router-link :to="paymentRouterLinkAction" class="paymentItem" >

      <div class="paymentItem_main">

        <div class="paymentItem_header">
          <h3>{{ bookingPaymentType }}</h3>

          <button class="paymentItem_editButton" type="button" @click.prevent v-if="canEditPaymentDueDate" data-toggle="modal" :data-target="dueDateModalId">
            <i class="fa fa-edit"></i>
          </button>

          <div>
            <span v-if="bookingPaymentIsOverdue" class="label label-danger">Overdue</span>
            <span v-else-if="bookingPaymentIsSent" class="label label-info">Sent</span>
          </div>

        </div>

        <p v-if="bookingPaymentIsSent"><i class="fa fa-calendar"></i> Sent On: {{ payment.sent_date | dateTimezone( $user.timezone, $user.date_format_preference, true) }}</p>
        <p v-else><i class="fa fa-calendar"></i> Due By: {{ payment.due_date | dateTimezone( $user.timezone, $user.date_format_preference, true) }}</p>

      </div>

      <div class="paymentItem_info">

        <div class="paymentItem_price">{{ payment.total_inclusive | currency }}{{ $showTax ? ' (inc tax)' : ''}}</div>

        <button class="paymentItem_paymentButton" type="button" >Make Payment</button>

      </div>

    </router-link>

    <booking-edit-payment-due-date-modal v-if="$userIsAdmin" :payment-id="payment.id" :payment-due-date="payment.due_date" :update-payment="updatePayment"/>
  </li>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { helpers, paymentHelpers } from 'mixins/bookings'
import BookingAlertUnpaidDeposit from './BookingAlertUnpaidDeposit'
import BookingEditPaymentDueDateModal from './BookingEditPaymentDueDateModal'

export default {
  components: {BookingEditPaymentDueDateModal, BookingAlertUnpaidDeposit},
  mixins: [helpers, paymentHelpers],

  props: {
    payment: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('booking', ['updatePayment'])
  },

  computed: {
    ...mapState('booking', ['booking']),

    canEditPaymentDueDate () {
      return this.$userIsBookingRegionalAdmin(this.$user, this.booking)
    },

    dueDateModalId () {
      return '#modal-edit-due-date' + '' + this.payment.id
    },

    paymentRouterLinkAction () {
      if (this.bookingTermsAreAccepted) {
        const action = this.payment.status === 'paid'
          ? 'view'
          : 'process'

        return { name: 'payments.show', params: { bookingId: this.booking.id, paymentId: this.payment.id, action } }
      }

      return {}
    }
  }
}
</script>

<style lang="scss" scoped >
.edit-button {
  display: inline-block;
  margin-top: 10px;
}
</style>
